import {
  AloftPrice,
  AloftPriceJSON,
  ManualAdjustments,
  MarketAdjustments,
} from '@aloft/toolkit-shared';

import { FormManualAdjustments, MarketAdjustmentsModalForm } from '../types.ts';

const priceToInputString = (price?: AloftPriceJSON): string =>
  AloftPrice.schema
    .parse(price ?? 0)
    .toDollarLike()
    .toString();

type Params = {
  manualAdjustments: Record<string, ManualAdjustments>;
  marketAdjustments: MarketAdjustments;
};

export const stateToForm = ({
  manualAdjustments: passedManualAdjustments,
  marketAdjustments: passedMarketAdjustments,
}: Params): MarketAdjustmentsModalForm => {
  const entries: [string, FormManualAdjustments][] = Object.entries(passedManualAdjustments).map(
    ([id, { concessions, termsOfSale }]) => [
      id,
      {
        concessions: priceToInputString(concessions),
        termsOfSale: priceToInputString(termsOfSale),
      },
    ],
  );

  return {
    manualAdjustments: Object.fromEntries(entries),
    marketAdjustments: {
      version: passedMarketAdjustments.version,
      cachedForms: {
        dateOfSale: {
          ...passedMarketAdjustments.cachedForms.dateOfSale,
          methodState: {
            ...(passedMarketAdjustments.cachedForms.dateOfSale.methodState.zillow !== undefined
              ? {
                  zillow: passedMarketAdjustments.cachedForms.dateOfSale.methodState.zillow,
                }
              : {}),
            customMonthlyRate: {
              rate: passedMarketAdjustments.cachedForms.dateOfSale.methodState.customMonthlyRate.rate.toString(),
            },
            customMonthlyPrice: {
              type: passedMarketAdjustments.cachedForms.dateOfSale.methodState.customMonthlyPrice
                .type,
              analysisPeriod:
                passedMarketAdjustments.cachedForms.dateOfSale.methodState.customMonthlyPrice
                  .analysisPeriod,
              trendsAsPercentages:
                passedMarketAdjustments.cachedForms.dateOfSale.methodState.customMonthlyPrice
                  .trendsAsPercentages,
              trends:
                passedMarketAdjustments.cachedForms.dateOfSale.methodState.customMonthlyPrice.trends.map(
                  (trend) => ({
                    month: trend.month,
                    value: priceToInputString(trend.value),
                  }),
                ),
            },
          },
        },
        listToSale: {
          selectedMethod: passedMarketAdjustments.cachedForms.listToSale.selectedMethod,
          methodState: {
            ...(passedMarketAdjustments.cachedForms.listToSale.methodState.customRatio?.ratio !==
            undefined
              ? {
                  customRatio: {
                    ratio:
                      passedMarketAdjustments.cachedForms.listToSale.methodState.customRatio.ratio.toString(),
                  },
                }
              : {}),
          },
        },
      },
    },
    commentary: passedMarketAdjustments.commentary,
  };
};
